import { JobsAPI } from '@/api';

export const JobsStore = {
  namespaced: true,
  state: {
    data: [],
    selected: {},
    show_modal: false,
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    openModal(state) {
      state.show_modal = true;
    },
    toggleModal(state, status) {
      state.show_modal = status;
    },
    closeModal(state) {
      state.show_modal = false;
    },
    setForEdit(state, data) {
      state.selected = _.cloneDeep(data);
    },
  },
  actions: {
    updateData({ state, commit }) {
      return JobsAPI.selectAll().then(res => {
        commit('setData', res.data);
      })
    },
    async remove({ dispatch }, item) {
      await JobsAPI.remove(item._id)
      await dispatch('updateData');
    },
    async save({ state, commit, dispatch }) {
      await JobsAPI.update(state.selected._id, state.selected)
      await dispatch('updateData');
      commit('closeModal');
    },
    async setActiveById({ dispatch, state }, { id, is_active }) {
      const item = state.data.find(item => item._id === id)
      const updatedItem = { ...item, is_active }
      await JobsAPI.update(id, updatedItem)
      await dispatch('updateData');
    }
  },
  getters: {
    data(state) {
      return state.data;
    },
    selected(state) {
      return state.selected;
    },
    showModal(state) {
      return state.show_modal;
    },
  },
}